// extracted by mini-css-extract-plugin
export default {"user":"styles__user___ZkJ0j","checkboxWrapper":"styles__checkboxWrapper___xMxqU","name":"styles__name___AiB4V"};